// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.box-disclaimer-pix-page {
  padding: 0 var(--spacing-small);
  line-height: 14px;
  margin: var(--spacing-small) 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.box-disclaimer-pix-page span {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-small);
  max-width: 572px;
}
.box-disclaimer-pix-page .ant-typography {
  font-size: var(--font-paragraph) !important;
  font-weight: 400 !important;
  line-height: 21px !important;
}
@media (max-width: 1024px) {
  .box-disclaimer-pix-page {
    flex-direction: column;
    gap: var(--spacing-small);
  }
}
.box-points-participant {
  width: 100%;
}
.box-points {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}
.box-points.highlight {
  color: var(--color-detached);
}
.box-points.default {
  color: #6D6C6E;
}
.box-points span {
  padding: 0 var(--spacing-small);
  height: 48px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
}
.box-points span h3 {
  font-family: var(--font-family);
  font-size: var(--font-title);
  font-weight: 500;
  line-height: 21px ;
  color: inherit;
}
.box-points span p {
  font-family: var(--font-family);
  color: inherit;
  font-size: 16px;
  font-weight: 600;
  line-height: 21px;
}
.loading-points-transfer {
  color: var(--color-detached);
  width: 25%;
  display: flex;
  justify-content: end;
  align-items: center;
}
.box-points-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  min-height: 48px;
}
.box-points-content {
  margin: var(--spacing-small) 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.box-points-divider {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}
.box-points-divider .ant-divider-vertical {
  height: 48px !important;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.typograph-title-pix-page {
  text-transform: uppercase;
}
.button-redirect-pix {
  margin: var(--spacing-small) 0;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/pages/pixPage/pixPage.less"],"names":[],"mappings":"AAAA;EAEE,+BAAA;EACA,iBAAA;EACA,8BAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;AAAF;AARA;EAeI,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;AAJJ;AAdA;EAsBI,2CAAA;EACA,2BAAA;EACA,4BAAA;AALJ;AASE;EAAA;IACE,sBAAA;IACA,yBAAA;EANF;AACF;AASA;EACC,WAAA;AAPD;AAUA;EACE,aAAA;EACA,qBAAA;EACA,yBAAA;AARF;AAWE;EACC,4BAAA;AATH;AAYE;EACE,cAAA;AAVJ;AADA;EAeE,+BAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,sBAAA;AAXF;AATA;EA0BI,+BAAA;EACA,4BAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAdJ;AAhBA;EAkCI,+BAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAfJ;AAoBA;EACE,4BAAA;EACA,UAAA;EACA,aAAA;EACA,oBAAA;EACA,mBAAA;AAlBF;AAsBA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,gBAAA;AApBF;AAuBA;EACE,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AArBF;AAyBA;EACE,aAAA;EACA,qBAAA;EACA,yBAAA;AAvBF;AAoBA;EAKI,uBAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;AAtBJ;AA8BA;EACE,yBAAA;AA5BF;AA+BA;EACE,8BAAA;AA7BF","sourcesContent":[".box-disclaimer-pix-page {\n  \n  padding: 0 var(--spacing-small) ;\n  line-height: 14px;\n  margin: var(--spacing-small) 0;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n\n\n\n  \n\n span{\n    display: flex;\n    flex-direction: column;\n    gap: var(--spacing-small);\n    max-width: 572px;\n  }\n\n  .ant-typography {\n    font-size: var(--font-paragraph) !important;\n    font-weight: 400 !important;\n    line-height: 21px !important;\n    \n  }\n\n  @media (max-width: 1024px)  {\n    flex-direction: column;\n    gap: var(--spacing-small);\n  }\n}\n\n.box-points-participant{\n width: 100%;\n\n}\n.box-points{\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n  \n\n  &.highlight{\n   color: var(--color-detached);\n  }\n\n  &.default{\n    color: #6D6C6E;\n  }\n  \n span {\n  padding: 0 var(--spacing-small);\n  height: 48px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  flex-direction: column;\n\n\n\n\n  h3{\n    font-family:var(--font-family);\n    font-size: var(--font-title) ;\n    font-weight: 500;\n    line-height: 21px ;\n    color: inherit;\n  }\n\n  p{\n    font-family:var(--font-family);\n    color: inherit;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 21px;\n  }\n }\n}\n\n.loading-points-transfer{\n  color: var(--color-detached);\n  width: 25%;\n  display: flex;\n  justify-content: end;\n  align-items: center;\n}\n\n\n.box-points-wrapper{\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  min-height: 48px;\n}\n\n.box-points-content{\n  margin: var(--spacing-small) 0;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  }\n\n\n.box-points-divider{\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n  .ant-divider-vertical{\n    height: 48px !important;\n    display: flex;\n    align-items: flex-end;\n    justify-content: center;\n\n  }\n\n}\n\n\n\n.typograph-title-pix-page {\n  text-transform: uppercase;\n}\n\n.button-redirect-pix {\n  margin: var(--spacing-small) 0;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
